import { render, staticRenderFns } from "./PETeacherWorkspace.vue?vue&type=template&id=4d0b0df4&scoped=true&"
import script from "./PETeacherWorkspace.vue?vue&type=script&lang=js&"
export * from "./PETeacherWorkspace.vue?vue&type=script&lang=js&"
import style0 from "./PETeacherWorkspace.vue?vue&type=style&index=0&id=4d0b0df4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0b0df4",
  null
  
)

export default component.exports